/*
 * File: cell-user-info.ts
 * Created: 2025-12-05 12:46:12
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-08 19:01:34
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiAlign: "l",
})
export default class CellUserInfo extends BaseTableBodyCell {
    get username() {
        return this.row.name;
    }
    get email() {
        return this.row.email;
    }

    get initials(): string {
        const name = (this.username || "").trim();
        const mail = (this.email || "").trim();

        // 優先使用名字
        if (name) {
            // 檢查是否包含雙位元組字元 (例如中文、日文、韓文)
            // eslint-disable-next-line no-control-regex
            const isDoubleByte = /[^\x00-\xff]/.test(name);

            if (isDoubleByte) {
                // 如果是中文等雙位元組語言，取第一個字
                return name.charAt(0);
            } else {
                // 如果是英文/拉丁語系，維持原本邏輯 (取首字母組合)
                const parts = name.split(/\s+/).filter(Boolean);
                if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
                return (parts[0][0] + (parts[1]?.[0] ?? "")).toUpperCase();
            }
        }

        // 如果沒有名字，改用 Email
        if (mail) {
            const head = mail.split("@")[0] || "";
            // Email 帳號通常是英文，取前兩個字母
            return head.slice(0, 2).toUpperCase();
        }

        return "--";
    }
}
